module.exports = {"pathContext":{"name":"TreatmentConnection","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"edges","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"TreatmentEdge","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"pageInfo","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"PageInfo","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-treatment-connection.json
// module id = 2051
// module chunks = 45765465763234